import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {
    CustomObjectEditPageComponent
} from "../../custom-object/custom-object-edit-page/custom-object-edit-page.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {Plugin} from "../../../config";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-custom-object-type-edit-page",
    templateUrl: "./custom-object-type-edit-page.component.html",
    providers: [provideEntityModel(CustomObjectTypeEntityModel)]
})
export class CustomObjectTypeEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;
    CustomObjectEditPageComponent = CustomObjectEditPageComponent;
    Plugin = Plugin;
    fixedType: boolean = false;

    constructor(public model: CustomObjectTypeEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
